import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=5b1b23bb&scoped=true&"
import script from "./Fade.vue?vue&type=script&lang=js&"
export * from "./Fade.vue?vue&type=script&lang=js&"
import style0 from "./Fade.vue?vue&type=style&index=0&id=5b1b23bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b23bb",
  null
  
)

export default component.exports